;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import type { ComponentProps } from 'react'

export function Heading({
  children,
  color = 'dark/light',
  fluidOnPhones = false,
  className,
  ...props
}: {
  color?: 'dark/light' | 'light'
  /**
   * Below `sm`, scale the size with the viewport instead of holding 44px, so a long unbreakable
   * word still fits the column. For headlines that end in one: the Dutch product H1s close on
   * `accountantskantoren.`, 8.4em wide, which at 44px ran past the hero card's clipping edge at
   * every phone width under 414px. Hyphenating the query word would look broken, so the type
   * shrinks instead: `11.5vw - 0.5rem` stays under the width that word can have in a column with
   * 32px on each side, and reaches 44px at 452px, from where the size is the same as without it.
   */
  fluidOnPhones?: boolean
} & ComponentProps<'h1'>) {
  return (
    <h1
      className={clsx(
        // From `lg` up — where the hero splits into text and visual — the size is fluid, so a
        // headline holds to two lines across that whole range rather than at one width only. It
        // stops growing at 54px, where the container stops growing too. Below `lg` the hero is a
        // single column and the headline wraps to as many lines as it needs.
        'font-display tracking-[-0.04em] text-balance',
        fluidOnPhones ? 'text-[clamp(1.75rem,11.5vw_-_0.5rem,2.75rem)]/[1.07]' : 'text-[2.75rem]/[1.07]',
        'lg:text-[clamp(2.375rem,3.75vw,3.375rem)]',
        '[&_b]:font-[inherit] [&_b]:text-accent-deep [&_b]:dark:text-accent-bright',
        color === 'dark/light' && 'text-mist-950 dark:text-white',
        color === 'light' && 'text-white',
        className,
      )}
      {...props}
    data-sentry-component="Heading" data-sentry-source-file="heading.tsx">
      {children}
    </h1>
  )
}
